const regexOnlyText = /^[A-zÀ-ú ]+$/g;

export { regexOnlyText };
